// src/services/csrf.js
import axios from "axios";
import { API_BASE } from "../config";

let primed = false;
let inflight = null;

// use a bare client with no interceptors to avoid recursion
const csrfClient = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export async function ensureCsrf() {
  if (primed || document.cookie.includes("XSRF-TOKEN=")) return;
  if (inflight) return inflight;
  inflight = csrfClient.get("/api/auth/csrf").catch(() => {}).finally(() => {
    primed = true;
    inflight = null;
  });
  return inflight;
}
